import { axiosGet, userData } from "../../Helpers";

export const loadJobSeekerFollowers = async (setLoading) => {
  // Followers are actually following
  const response = await axiosGet(`user/followers/${userData.id}`);
  console.log("response", response);
  setLoading(false);
  return response.data.data;
};
export const loadJobSeekerFollowings = async (setLoading) => {
  // letSeeWhatHappensHere!
  const response = await axiosGet(`user/followings/${userData.id}`);
  console.log("response", response);
  setLoading(false);
  return response.data.data;
};
